import { useState } from "react";
import { Lock } from "lucide-react";
import Logo from "@/components/Logo";
import api, { formatApiErrorDetail, authHeaders } from "@/lib/api";

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("brox_admin_token", data.access_token);
      onLogin(data.user);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink-950 px-5" data-testid="admin-login-view">
      <form onSubmit={submit} className="w-full max-w-md border border-white/10 bg-ink-900 p-8 sm:p-10" data-testid="admin-login-form">
        <Logo />
        <div className="mt-8 space-y-5">
          <div>
            <label htmlFor="admin-email" className="label-brox">Email administrator</label>
            <input id="admin-email" type="email" required className="input-brox" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" />
          </div>
          <div>
            <label htmlFor="admin-password" className="label-brox">Parolă</label>
            <input id="admin-password" type="password" required className="input-brox" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" />
          </div>
          {error && <p className="border border-red-500/40 bg-red-500/10 px-4 py-3 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="admin-login-submit">
            <Lock className="h-4 w-4" />
            {busy ? "SE AUTENTIFICĂ..." : "AUTENTIFICARE"}
          </button>
        </div>
        <p className="mt-6 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">BROX CONSTRUCT — PANOU ADMINISTRARE</p>
      </form>
    </div>
  );
}
